import React, { useState } from 'react'
import styles from './AttachedProductsSection.module.scss'
import { Button, AddedItem, ObjectsPopupSelector } from 'components'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { BRAND_STORE, SourceTypes } from 'store'
import { getObjId } from 'utilities'
import { AttachedProductsSectionProps } from './AttachedProductsSection.types'

const AttachedProductsSection = (props: AttachedProductsSectionProps) => {
  const {
    brands,
    setBrands,
    [BRAND_STORE]: {
      getBrands, brandsList, getBrandById, brandToView,
      setBrandToView, clearStoreObservables
    }
  } = props
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [showPopup, setShowPopup] = useState(false)
  const [productSource, setProductSource] = useState<SourceTypes>(SourceTypes.STUDIO)

  const handleAddProductClick = () => {
    setBrandToView()
    getBrands(false, false, productSource)
    setShowPopup(true)
  }

  const handlePopupBrandSelect = ([brandName]) => {
    const { id, externalId } = brandsList.find(b => b.name === brandName)

    const brandId = {
      studio: id,
      marketplace: externalId
    }[productSource]

    setBrandToView()
    getBrandById(brandId, true, false, productSource)
  }

  const getSelectedObjectList = () => {
    return (brands.find(b => b.externalId === brandToView.externalId) || {}).products || []
  }

  const handleOnPopupSelect = selectedProductsList => {
    let cloneBrands = []
    if (selectedProductsList.length === 0) {
      cloneBrands = [...brands.filter(b => b.externalId !== brandToView.externalId)]
    } else {
      const index = brands
        .findIndex(b => b.externalId === selectedProductsList[0].brandExternalId)
      cloneBrands = [...brands]
      if (index < 0) {
        const brandToAdd = { ...brandToView, products: selectedProductsList }
        cloneBrands.push(brandToAdd)
      } else {
        cloneBrands[index].products = selectedProductsList
      }
    }

    setBrands(cloneBrands)
  }

  const handleOnRemoveProduct = productId => {
    const newProducts = brands[selectedTabIndex].products
      .filter(p => getObjId(p) !== productId)
    const cloneBrands = [...brands]
    if (!newProducts.length) {
      cloneBrands.splice(selectedTabIndex, 1)
    } else {
      cloneBrands[selectedTabIndex].products = newProducts
    }
    setBrands(cloneBrands)
  }

  const isToggleSwitched = productSource === SourceTypes.MARKETPLACE

  const onToggleSwitch = () => {
    const newValue = isToggleSwitched ? SourceTypes.STUDIO : SourceTypes.MARKETPLACE
    setProductSource(newValue)
    setBrandToView()
    getBrands(false, false, newValue)
  }

  const onPopupSelectorClose = () => {
    clearStoreObservables()
    setShowPopup(false)
  }

  return (
    <div className={styles.container}>
      <label>Products</label>

      <div className={styles.productsContainer}>

        <div className={styles.tabsContainer}>

          {brands.map((brand, index) =>
            <Button
              key={index}
              size='small'
              onClick={() => setSelectedTabIndex(index)}
              className={selectedTabIndex === index ? styles.selectedTab : ''}
            >
              {brand.name}
            </Button>
          )}

        </div>

        {brands.length
          ? <div className={styles.productItemsContainer}>
            {brands[selectedTabIndex] &&
              brands[selectedTabIndex].products.map(product =>
                <AddedItem
                  key={getObjId(product)}
                  item={product}
                  type='product'
                  onRemove={handleOnRemoveProduct}
                />
              )}
          </div>
          : null}

        <Button
          type='add'
          size='small'
          onClick={handleAddProductClick}
          className={styles.addProductsBttn}
        >
          Add Product
        </Button>

      </div>

      {showPopup &&
        <ObjectsPopupSelector
          title='Manage Attached Products'
          onClose={onPopupSelectorClose}
          dropdownFilterOptions={brandsList.map(b => b.name)}
          dropdownLabel='Brand'
          dropdownPlaceholder='Select brand'
          dropdownOnSelect={handlePopupBrandSelect}
          objectsList={brandToView.products || []}
          selectedObjectsList={getSelectedObjectList()}
          setSelectedList={handleOnPopupSelect}
          toggleOptions={Object.values(SourceTypes)}
          toggleSwitched={isToggleSwitched}
          onToggleSwitch={onToggleSwitch}
        />
      }
    </div>
  )
}

export default inject(BRAND_STORE)(observer(AttachedProductsSection))
